import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material'

import DiagnosticPage from './Diagnostic'
import PurchaseDiagnosticPage from './PurchaseDiagnostic'
import QuestionnairePage from './QuestionnairePage'
import CartPage from './Cart'
import SuccessPage from './Success'
import ResultPage from './Result'
import ScorePage from './ScorePage'
import FoodScan from './FoodScan'
import FoodBreakDown from './FoodBreakdown'
import FoodScanProceed from './FoodScan/FoodScanProceed'
import CKDRoute from './Programs/CKD/route'
import PodcastDetailsPage from './Programs/CKD/PodcastDetails'
import CKDAwarenessPage from './Programs/CKD/Awareness'

import '../styles/main.css'
import BooksPage from './Books'
import AboutPage from './About'
import PodcastsPage from './Podcasts'

const isMobileDevice = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

const AppRoutes = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#8C2FDF',
      },
      secondary: {
        main: '#54595F',
      },
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* CDK Routes */}
          <Route path="/ckd/questionnaire" Component={QuestionnairePage} />
          <Route path="/cart" Component={CartPage} />
          <Route path="/book-diagnostic" Component={DiagnosticPage} />
          <Route
            path="/purchase-diagnostic"
            Component={PurchaseDiagnosticPage}
          />
          <Route path="/result" Component={ResultPage} />
          <Route path="/success" Component={SuccessPage} />
          <Route path="/scan-food/capture" Component={FoodScan} />
          <Route path="/scan-food/proceed" Component={FoodScanProceed} />
          <Route path="/food-breakdown" Component={FoodBreakDown} />
          <Route path="/score" Component={ScorePage} />
          <Route path="/ckdbook" Component={BooksPage} />
          <Route path="/about" Component={AboutPage} />
          <Route path="/podcasts" Component={PodcastsPage} />
          <Route path="/awareness-films" Component={CKDAwarenessPage} />
          <Route path="/podcast/:podcastId" Component={PodcastDetailsPage} />
          <Route path="/" Component={CKDRoute} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default AppRoutes
